import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20in%20coral%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20smooth%20curves%2C%20modern%20minimalist%20design%2C%20ethereal%20glow%2C%20dark%20rich%20warm%20colors%2C%20video%20platform%20hero%20background&width=1800&height=900&seq=mogu-hero-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm font-label mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line text-accent-400"></i>
            </div>
            超过100万部高清视频 · 每日更新
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            海量高清视频
            <br />
            <span className="text-primary-300">随时随地免费看</span>
          </h1>
          <p className="text-white/75 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
            蘑菇视频在线观看平台汇聚海量高清视频资源，覆盖纪录片、科技、影视、教育、美食等多个领域。无需下载，打开浏览器即可流畅观看，支持多终端多分辨率。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/documentary"
              className="px-8 py-3 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即探索
              <div className="w-4 h-4 inline-flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-lg bg-white/15 backdrop-blur-sm border border-white/30 text-white font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-10 text-white/60 text-xs">
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-shield-check-line text-[10px]"></i>
              </div>
              安全可靠
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-flashlight-line text-[10px]"></i>
              </div>
              极速播放
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-smartphone-line text-[10px]"></i>
              </div>
              多端适配
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-4k-line text-[10px]"></i>
              </div>
              高清画质
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}